<main id="main" class="main mb-5">
  <div class="row">
    <div class="col-md-12">
      <h6 class="admintitle">
        Settings&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
      </h6>
    </div>
  </div>

  <!-- Horizontal Navigation -->
   <div class="col-12 d-flex justify-content-evenly tabs">
      <div 
      class="tab w-100 justify-content-between" 
      *ngFor="let category of categories" 
      [ngClass]="{ active: selectedCategory === category }"
      (click)="selectedCategory=category">
      {{category}}
    </div>
  </div>


  <div *ngFor="let obj of categoryList; let i = index">
    <div *ngIf="obj.category == selectedCategory">
      <div *ngIf="obj.category=='MAIL'&& obj.settingsKey != 'mail_details'">
        <p class="heading-p">{{ obj.settingsKeyLabel }}</p>
        <div class="d-flex">
          <div>
            <p>{{getSettingsKey(obj.settingsValueLabels,'SERVERS')}}</p>
            <div *ngFor="let item of getParseData(obj.settingsValue)?.SERVERS | keyvalue; let j = index; trackBy: trackByFn" class="servers">
              <!-- <div class="accordion" (click)="toggleAccordion1($event, i, 0, j)" [ngClass]="{'active': data1[i][0][j].isActive}">
                <button class="accordion-button">{{ item.key }}</button>
              </div> -->
              <div class="accordion" (click)="toggleAccordion1($event, i, 0, j)" [ngClass]="{'active': data1[i][0][j].isActive}">
                <button class="accordion-button">
                  {{ item.key }}
                  <span [ngClass]="data1[i][0][j].isActive ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" style="float: right;"></span>
                </button>
              </div>

              <div class="panel" [ngStyle]="{'max-height': data1[i][0][j].isActive? '300px' : '0'}" style="overflow: hidden;">
                <div class="row">
                  <div class="col-12">
                    <input
                      id="settings-{{i}}-0-{{j}}"
                      type="checkbox" 
                      [disabled]="item.key==(details[i].value?.SELECTED??details[i].value?.DEFAULT)"
                      [checked]="item.key==(details[i].value?.SELECTED??details[i].value?.DEFAULT)" 
                      (change)="setDefaultServer('SELECTED',item.key, i)"
                    /> 
                    <label for="settings-{{i}}-0-{{j}}" class="mx-2">
                      {{item.key==(details[i].value?.SELECTED??details[i].value?.DEFAULT)?'Default':'Make default'}}
                    </label>
                  </div>
                  <div class="col-md-6" *ngFor="let object of item.value | keyvalue">
                    <label>{{getSettingsKey(obj.settingsValueLabels,object.key)}}</label>
                    <input
                      class="form-control"
                      [disabled]="object.key === 'host'"
                      value="{{details[i]?.value?.SERVERS[item.key]?.[object.key] || ''}}"
                      (change)="handleChangeDetails($event,i,'SERVERS',item.key,object.key)"
                    />
                  </div>
                  <div class="d-flex justify-content-end">
                    <button class="btn-primary addgroupadmininfoemp" (click)="UpdatesmtpMail(i)">Update</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <p>{{getSettingsKey(obj.settingsValueLabels,'ALT_SERVERS')}}</p>
            <div *ngFor="let item of getParseData(obj.settingsValue)?.ALT_SERVERS | keyvalue; let j = index; trackBy: trackByFn" class="servers">
              <!-- <div class="accordion" (click)="toggleAccordion1($event, i ,1, j)" [ngClass]="data1[i][1][j].isActive?'fa fa-chevron-right':'fa fa-chevron-down'">
                <button class="accordion-button">{{ item.key }}</button>
              </div> -->
              <div class="accordion" (click)="toggleAccordion1($event, i, 1, j)" [ngClass]="{'active': data1[i][1][j].isActive}">
                <button class="accordion-button">
                  {{ item.key }}
                  <span [ngClass]="data1[i][1][j].isActive ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" style="float: right;"></span>
                </button>
              </div>

              <div class="panel" [ngStyle]="{'max-height': data1[i][1][j].isActive ? '300px' : '0'}" style="overflow: hidden;">
                <div class="row">
                  <div class="col-12">
                    <input 
                      id="settings-{{i}}-1-{{j}}"
                      type="checkbox" 
                      [disabled]="item.key==(details[i].value?.ALT_SELECTED??details[i].value?.ALT_DEFAULT)" 
                      [checked]="item.key==(details[i].value?.ALT_SELECTED??details[i].value?.ALT_DEFAULT)" 
                      (change)="setDefaultServer('ALT_SELECTED',item.key, i)"
                    /> 
                    <label for="settings-{{i}}-1-{{j}}" class="mx-2">
                      {{item.key==(details[i].value?.ALT_SELECTED??details[i].value?.ALT_DEFAULT)?'Default':'Make default'}}
                    </label>
                  </div>
                  <div class="col-md-6" *ngFor="let object of item.value | keyvalue">
                    <label>{{getSettingsKey(obj.settingsValueLabels,object.key)}}</label>
                    <input
                      class="form-control"
                      [disabled]="object.key === 'host'"
                      value="{{details[i]?.value?.ALT_SERVERS[item.key]?.[object.key] || ''}}"
                      (change)="handleChangeDetails($event,i,'ALT_SERVERS',item.key,object.key)"
                    />
                  </div>
                  <div class="d-flex justify-content-end">
                    <button class="btn-primary addgroupadmininfoemp" (click)="UpdatesmtpMail(i)">Update</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div *ngIf="obj.category=='MAIL' && obj.settingsKey == 'mail_details'">
        <p class="heading-p mt-3">{{ obj.settingsKeyLabel }}</p>
        <div class="row">
          <div *ngFor="let setting of getParseData(obj.settingsValue) | keyvalue" class="col-md-4">
            <label>{{getSettingsKey(obj.settingsValueLabels,setting.key)}}</label>
            <input class="form-control" [(ngModel)]="details[i].value[setting.key]" />
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn-primary addgroupadmininfoemp" (click)="UpdatesmtpMail(i)">Update</button>
          </div>
        </div>
      </div>

      <!-- <p class="heading-p">{{ obj.settingsKeyLabel }}</p> -->
      <!-- <div class="accordion" (click)="toggleAccordion($event, i)">
        <button class="accordion-button">{{ obj.settingsKeyLabel }}</button>
      </div> -->
      <div *ngIf="obj.category!='MAIL'" class="servers">
        <div class="accordion" (click)="toggleAccordion($event, i)" [ngClass]="{'active': data[i].isActive}">
          <button class="accordion-button">
            {{ obj.settingsKeyLabel }}
            <span [ngClass]="data[i].isActive ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" style="float: right;"></span>
          </button>
        </div>
    
        <div class="panel" [ngStyle]="{'max-height': data[i].isActive ? '300px' : '0'}" style="overflow: hidden;">
          <div class="row">
            <div *ngFor="let setting of getParseData(obj.settingsValue) | keyvalue" class="col-md-4">
              <label>{{getSettingsKey(obj.settingsValueLabels,setting.key)}}</label>
              <input class="form-control" [(ngModel)]="details[i].value[setting.key]" />
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn-primary addgroupadmininfoemp" (click)="UpdatesmtpMail(i)">Update</button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="obj.category=='MAIL' && obj.settingsKey == 'mail_details'">{{obj|json}}</div> -->

    </div>
  </div>

<!-- Settings for Cloey -->
 <p class="heading-p mt-2">Cloey Configuration</p>
    <div class="servers col-md-6">
      <div class="accordion">
        <button class="accordion-button">
          Enable/Disable Cloey
        </button>
      </div>
  
      <div class="panel" style="overflow: visible; max-height:  300px; padding: 10px;">
        <div>
          <div class="col-md-12 d-flex">
            <label class="form-label col-md-4">Disable Cloey</label>
            <div class="form-check me-4">
              <input class="form-check-input" type="radio" name="disableCloey" id="disableYes" [(ngModel)]="disableCloeySelection" value="yes">
              <label class="form-check-label" for="disableYes">Yes</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="disableCloey" id="disableNo" [(ngModel)]="disableCloeySelection" value="no">
              <label class="form-check-label" for="disableNo">No</label>
            </div>
          </div>
          <!-- <div class="col-md-8 d-flex">
            <label class="form-label">Enable Cloey for selected Advisors</label>
            <ng-select 
            name="advisorSelect"
            [items]="advisorList"
            bindLabel="name"
            bindValue="id"
            [multiple]="true"
            placeholder="Select advisors"
            [(ngModel)]="selectedAdvisors"
            [disabled]="disableCloeySelection === 'yes'"
            class="form-control">
            <ng-template ng-option-tmp let-item="item">
              <input type="checkbox" [checked]="selectedAdvisors.includes(item.id)"/> {{ item.name }}
            </ng-template>
          </ng-select>
          </div> -->
          <div class="form-group col-md-12 d-flex space-between">
            <label for="multiSelectAdvisor" class="Corporation col-md-4" style="margin-right:10px; display: inline-block;">Enable Cloey for selected Advisors</label>
            
              <ng-multiselect-dropdown class=" z-100 d-inline-flex" 
                placeholder="Select Advisor" [settings]="dropdownSettings" [data]="advisorList"
                [formControl]="form.get('multiSelectAdvisor')"
                (onSelect)="multiSelectAdvisorItemSelect($event)"
                (onSelectAll)="multiSelectAdvisorSelectAll($event)"
                (onDeSelect)="multiSelectAdvisorItemDeSelect($event)" (onDeSelectAll)="
                  multiSelectAdvisorItemDeSelectAll($event)
                " style="background-color: rgb(232, 234, 240); width: 50%;">
              </ng-multiselect-dropdown>
            
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn-primary addgroupadmininfoemp" (click)="UpdateCloey()">Update</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Authorize net -->
    <p class="heading-p mt-2">Authorize net Configuration</p>
    <div class="servers col-md-6">
      <div class="panel" style="overflow: visible; max-height:  300px; padding: 10px;">
        <div>
          <div class="row">
            <div class="col-md-4">
              <label class="form-label col-md-4">Auth date</label>
            </div>
            <div class="col-md-4">
              <input 
                type="text" 
                class="form-control border border-dark" 
                placeholder="MM-DD-YYYY"
                [minDate]="minDate" 
                [maxDate]="maxDate" 
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" 
                placeholder="MM-DD-YYYY" 
                bsDatepicker
                (keypress)="numbersOnly($event)"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <label class="form-label col-md-4">Capture date</label>
            </div>
            <div class="col-md-4">
              <input 
                type="text" 
                class="form-control border border-dark" 
                placeholder="MM-DD-YYYY"
                [minDate]="minDate" 
                [maxDate]="maxDate" 
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" 
                placeholder="MM-DD-YYYY" 
                bsDatepicker
                (keypress)="numbersOnly($event)"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <label class="form-label col-md-4">Retry date</label>
            </div>
            <div class="col-md-4">
              <input 
                type="text" 
                class="form-control border border-dark" 
                placeholder="MM-DD-YYYY"
                [minDate]="minDate" 
                [maxDate]="maxDate" 
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" 
                placeholder="MM-DD-YYYY" 
                bsDatepicker
                (keypress)="numbersOnly($event)"
              />
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn-primary addgroupadmininfoemp">Update</button>
          </div>
        </div>
      </div>
    </div>

  <!-- <div *ngFor="let obj of categoryList; let i = index">
    <div *ngIf="obj.category == selectedCategory">
      <div *ngIf="obj.category == 'MAIL'">
        <p class="heading-p">{{ obj.settingsKeyLabel }}</p>
        <div class="d-flex">
          <div>
            <p>{{ getSettingsKey(obj.settingsValueLabels, 'SERVERS') }}</p>
            <div *ngFor="let item of getParseData(obj.settingsValue)?.SERVERS | keyvalue; let j = index">
              <div class="accordion" (click)="toggleAccordion($event, i, j)">
                <button class="accordion-button">{{ item.key }}</button>
              </div>
              <div class="panel" [ngStyle]="{'max-height': obj.isActive ? '300px' : '0'}" style="overflow: hidden;">
                <div class="row">
                  <div class="col-md-6" *ngFor="let object of item.value | keyvalue">
                    <label>{{ getSettingsKey(obj.settingsValueLabels, object.key) }}</label>
                    <input class="form-control" [disabled]="object.key == 'host'" value="{{ object.value }}" />
                  </div>
                  <div class="d-flex justify-content-end">
                    <button class="btn-primary addgroupadmininfoemp">Update</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div>
            <p>{{ getSettingsKey(obj.settingsValueLabels, 'ALT_SERVERS') }}</p>
            <div *ngFor="let item of getParseData(obj.settingsValue)?.ALT_SERVERS | keyvalue; let j = index">
              <div class="accordion" (click)="toggleAccordion1($event, i, j)">
                <button class="accordion-button">{{ item.key }}</button>
              </div>
              <div class="panel" [ngStyle]="{'max-height': obj.isActive ? '300px' : '0'}" style="overflow: hidden;">
                <div class="row">
                  <div class="col-md-6" *ngFor="let object of item.value | keyvalue">
                    <label>{{ getSettingsKey(obj.settingsValueLabels, object.key) }}</label>
                    <input class="form-control" [disabled]="object.key == 'host'" value="{{ object.value }}" />
                  </div>
                  <div class="d-flex justify-content-end">
                    <button class="btn-primary addgroupadmininfoemp">Update</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div *ngIf="obj.category != 'MAIL'">
        <p class="heading-p">{{ obj.settingsKeyLabel }}</p>
        <div class="accordion" (click)="toggleAccordion($event, i)">
          <button class="accordion-button">{{ obj.settingsKeyLabel }}</button>
        </div>
        <div class="panel" [ngStyle]="{'max-height': obj.isActive ? '300px' : '0'}" style="overflow: hidden;">
          <div class="row">
            <div *ngFor="let setting of getParseData(obj.settingsValue) | keyvalue" class="col-md-4">
              <label>{{ getSettingsKey(obj.settingsValueLabels, setting.key) }}</label>
              <input class="form-control" [(ngModel)]="setting.value" />
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn-primary addgroupadmininfoemp">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  
  
  
  <div class="row">

    <!-- <img src="../../../assets//img/Settings.png"> -->

    <!-- <div class="row">
      <div class="col-md-12">
        <label>
          {{settingsKeyLabel}}&nbsp;&nbsp;
        </label>
      </div>
    </div> -->
    <!-- <div class="row">
      <form [formGroup]="mailConfigSmtp">
        <div class="row">
          <div class="form-group col 12 col-md-4">
            <label for="memberType">Username<span class="text-danger">*</span></label>
            <input type="email" class="form-control checking-field border border-dark" id="userName"
            placeholder="userName"
        formControlName="username" />
        <div *ngIf="mailFormGet['username'].touched && mailFormGet['username'].invalid" class="help-block text-danger">
          <div *ngIf="mailFormGet['username'].errors && mailFormGet['username'].hasError('required')">
            Please enter other role
          </div>
          </div>
          </div>
          <div class="form-group col 12 col-md-4">
            <label for="memberType">Password<span class="text-danger">*</span></label>
            <input type="text" class="form-control checking-field border border-dark" id="Password"
            placeholder="Password"
        formControlName="password" />
        <div *ngIf="mailFormGet['password'].touched && mailFormGet['password'].invalid" class="help-block text-danger">
          <div *ngIf="mailFormGet['password'].errors && mailFormGet['password'].hasError('required')">
            Please enter other role
          </div>
          </div>

          </div>
          <div class="form-group col-md-4">
            <button class="btn-primary addgroupadmininfoemp" (click)="UpdatesmtpMail()">Update</button>
          </div>
        </div>
        </form>
    </div> -->

    <!-- <div class="row">
      <div class="col-md-12">
        <label>
          {{ccSettingsKeyLabel}}&nbsp;&nbsp;
        </label>
      </div>
    </div>
    <div class="row">
      <form [formGroup]="cCmailConfigSmtp">
        <div class="row">
          <div class="form-group col 12 col-md-4">
            <label for="memberType">GB Suport mail<span class="text-danger">*</span></label>
            <input type="email" class="form-control checking-field border border-dark" id="userName"
            placeholder="GB Suport mail"
        formControlName="gbSuportMail" />
        <div *ngIf="cCmailConfigSmtpGet['gbSuportMail'].touched && cCmailConfigSmtpGet['gbSuportMail'].invalid" class="help-block text-danger">
          <div *ngIf="cCmailConfigSmtpGet['gbSuportMail'].errors && cCmailConfigSmtpGet['gbSuportMail'].hasError('required')">
            Please enter other role
          </div>
          </div>
          </div>
          <div class="form-group col 12 col-md-4">
            <label for="memberType">Email Regards Student<span class="text-danger">*</span></label>
            <input type="text" class="form-control checking-field border border-dark" id="Password"
            placeholder="Email Regards Student"
        formControlName="mailRegardsStudent" />
        <div *ngIf="cCmailConfigSmtpGet['mailRegardsStudent'].touched && cCmailConfigSmtpGet['mailRegardsStudent'].invalid" class="help-block text-danger">
          <div *ngIf="cCmailConfigSmtpGet['mailRegardsStudent'].errors && cCmailConfigSmtpGet['mailRegardsStudent'].hasError('required')">
            Please enter other role
          </div>
          </div>

          </div>

        </div>
        <div class="row">
          <div class="form-group col 12 col-md-4">
            <label for="memberType">System Admin Mail<span class="text-danger">*</span></label>
            <input type="email" class="form-control checking-field border border-dark" id="userName"
            placeholder="GB Suport mail"
        formControlName="systemAdminMail" />
        <div *ngIf="cCmailConfigSmtpGet['systemAdminMail'].touched && cCmailConfigSmtpGet['systemAdminMail'].invalid" class="help-block text-danger">
          <div *ngIf="cCmailConfigSmtpGet['systemAdminMail'].errors && cCmailConfigSmtpGet['systemAdminMail'].hasError('required')">
            Please enter other role
          </div>
          </div>
          </div>
          <div class="form-group col 12 col-md-4">
            <label for="memberType">System Admin mail name<span class="text-danger">*</span></label>
            <input type="text" class="form-control checking-field border border-dark" id="Password"
            placeholder=""
        formControlName="systemAdminName" />
        <div *ngIf="cCmailConfigSmtpGet['systemAdminName'].touched && cCmailConfigSmtpGet['systemAdminName'].invalid" class="help-block text-danger">
          <div *ngIf="cCmailConfigSmtpGet['systemAdminName'].errors && cCmailConfigSmtpGet['systemAdminName'].hasError('required')">
            Please enter other role
          </div>
          </div>

          </div>

        </div>
       <div class="row">
        <div class="form-group col 12 col-md-4">
          <label for="memberType">Mail Regards<span class="text-danger">*</span></label>
          <input type="email" class="form-control checking-field border border-dark" id="userName"
          placeholder="GB Suport mail"
      formControlName="emailRegards" />
      <div *ngIf="cCmailConfigSmtpGet['emailRegards'].touched && cCmailConfigSmtpGet['emailRegards'].invalid" class="help-block text-danger">
        <div *ngIf="cCmailConfigSmtpGet['emailRegards'].errors && cCmailConfigSmtpGet['emailRegards'].hasError('required')">
          Please enter Mail Regards
        </div>
        </div>
        </div>
       </div>
        </form>
    </div> -->



  </div>
</main>
